import React from 'react';

interface Props {}

const GridBreak = (props: Props) => {
  return <div style={{ width: '100%' }} />;
};

export default GridBreak;
